exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".msgDstail{min-height:calc(100vh - 60px)}.msgContent,.myInput{width:45%}.myInput{display:inline-block;margin-right:10px}.logoImg{width:30%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2151cd1c!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/secretary/message/msgDetail.vue
// module id = 470
// module chunks = 0